import { HeroVisualSitemapGenerator } from '@/-sections/Heroes/Sitemaps/Generator'
import { Box, DarkMode, LightMode } from '@chakra-ui/react'
import Logos from '@/-sections/Logos'
import { GeneratorSteps } from '@/-sections/Sitemaps/Generator/Steps'
import { GeneratorFAQs } from '@/-sections/FAQs/Generator'
import { Footer } from '@/-components/Footer'
import { ChooseRarchy } from '@/-sections/Sitemaps/Generator/ChooseRarchy'
import { JoinBanner } from '@/-sections/JoinBanner'
import { SitemapEditor } from '@/-sections/Sitemaps/Editor'

const Generator = () => {
    return (
        <DarkMode>
            <Box w="full" bg="white">
                <Box w="full" bg="blue.600" py={{ base: 10, lg: 20 }} pb={{ base: 24, lg: 40 }}>
                    <HeroVisualSitemapGenerator />
                </Box>
                <LightMode>
                    <Logos />
                    <GeneratorSteps />
                    <Box py={{ base: 16, lg: 32 }} bgColor="gray.50">
                        <SitemapEditor />
                    </Box>
                    <Box pt={{ base: 16, lg: 32 }}>
                        <ChooseRarchy />
                    </Box>
                    <GeneratorFAQs />
                    <JoinBanner bgColor="#034024" />
                </LightMode>
            </Box>
            <Footer bgColor="#034024" />
        </DarkMode>
    )
}

export default Generator